$(document).ready(function() {
	// base url
	if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
		var path = '/cefim/';
	} else {
		var path = '/';
	}

	var token = $('html').attr('token');
	var lang = $('html').attr('lang');
	var data_table_i18n = { 'fr': 'French', 'en' : 'English', 'nl' : 'Dutch'};

	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// init datatable
	if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
			"language": {
				"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/"+data_table_i18n[lang]+".json"
			},
			"pageLength": 25,
			"aaSorting": []
		});

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;
			
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );
		    
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}

	// init datepicker
	$('.datepicker').datepicker({
		format: "dd-mm-yyyy",
		weekStart: 1,
		daysOfWeekDisabled: "0,6",
		startDate: '0d'
	});

	// PopUp Modal
	$('#PopUpModal').modal('show');

	// slider homepape
	$('.slider-product-homepage').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: true,
		responsive: [
		{
			breakpoint: 1400,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	    ]
	});

	// product details slider
	$('.slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.slider-nav'
	});
	$('.slider-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.slider-for',
		dots: false,
		focusOnSelect: true,
		responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	    ]

	});


	// init selectpicker
	$('.selectpicker').selectpicker();
	$(document).on('click', '.bootstrap-select button', function(e) {
		e.preventDefault();
		return false;
	});

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file, data) {
		switch(file) {
			case 'formation/search-training':
			var filter = [];
			var cat = [];
			var search = $('#search-training').val();
			var page = $('#paginations .page-item.active').attr('id');
			if (page === undefined) {
				page = 1;
			}

			$('input[data-search-cat]:checked').each(function(i) {
				filter.push($(this).val());
				cat.push($(this).data('search-cat'));
			});

			var range = '1;Cycle';
			var duree = '1;Cycle';

			data[data.length] = { name: 'filter[]', value: filter };
			data[data.length] = { name: 'cat[]', value: cat };
			data[data.length] = { name: 'search', value: search };
			data[data.length] = { name: 'page', value: page };
			data[data.length] = { name: 'range', value: range };
			data[data.length] = { name: 'duree', value: duree };
			break;
			default:
			return true;
		}
	}
	
	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response) {
		switch(callback) {
			case  'formation/subscription':
			toastr.success(response.msg);
			$('#modal-subscription').modal('hide');
			$('#modal-subscription').find('input:not([type=hidden])').val('');
			$('#modal-subscription').find('input[type=checkbox]').prop('checked', false);
			break;
			case  'formation/cll-subscription':
			toastr.success(response.msg);
			$('#modal-cll-subscription').modal('hide');
			$('#modal-cll-subscription').find('input:not([type=hidden])').val('');
			$('#modal-cll-subscription').find('input[type=checkbox]').prop('checked', false);
			break;
			case  'formation/mdlc-subscription':
			toastr.success(response.msg);
			$('#modal-mdlc-subscription').modal('hide');
			$('#modal-mdlc-subscription').find('input:not([type=hidden])').val('');
			$('#modal-mdlc-subscription').find('input[type=checkbox]').prop('checked', false);
			break;
			default:
			return true;
		}
	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			if(confirm('Voulez-vous supprimer cette ligne ?')) {
				$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
					if(response.action == 'success') {

						if(response.callback === true) {
							xhr_success(file, response);
						}
						else {
							if(response.msg != null) {
								toastr.success(response.msg);
							}
							$this.closest('[data-id]').remove()					
						}

						if(response.url != null) {
							location.href = response.url;
						}
					}
					else if(response.action == 'empty') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
					}
					else if(response.action == 'token') {
						location.reload();
					}   
					else {
						if(response.msg != null) {
							toastr.error(response.msg);
						}
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
					}
				}, 'json')
				.always(function(jqXHR) {
					if(jqXHR.status == 404) {			    	
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					}
					else if(jqXHR.status == 500) {			    	
						toastr.error('Request error. Please contact the support');

						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					}
				});
			}
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
					if (data[index].name == currentEditorId) {
						data[index].value = val;
					}
				}
			});

			xhr_data(file, data);

			$('.input__field--error').removeClass('input__field--error');
			$.post(path+'Connections/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						location.href = response.url;
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
						$(form).find('#'+item).addClass('input__field--error');
					});
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
				}
			}, 'json')
			.always(function(jqXHR) {
				if(jqXHR.status == 404) {			    	
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				}
				else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				}
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	$(document).on('click', '#trigger-filtres-mobile', function(e) {
		$('#filtres-content').toggleClass('d-none');
		e.preventDefault();
		
	});

	$(document).on('click', '#trigger-nav-account', function(e) {
		$('#pills-tab').toggleClass('d-none');
		e.preventDefault();
		
	});

	// slider temoignages
	$('.slider-temoignages').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows:false,
		dots:false
	});

	$('.slider-video').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows:false,
		dots:false,
		infinite: true,
	});

	// formulaire de contact
	$(document).on('submit', '#form-contact', function(e) {	
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path+'Connections/request/xhr/contact/send-contact.php', data, function(response) {
			if(response.action == 'success') {

				toastr.success(response.msg);
				$('#alert').html('<div class="alert alert-success" role="alert">Message successfully sent !</div>');
				$('input, textarea, select').each(function(){
					$(this).val('');
					$('input[type=checkbox]').prop('checked', false);
				});
				
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// update des données du user
	$(document).on('submit', '#form-user-data', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-user-data.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-recovery', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/recovery.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				//location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('keyup', '#form-new-account input[name=password]', function() {
		var password = $('#form-new-account input[name=password]').val();
		check_pw('#form-new-account input[name=password]');			
	});

	$(document).on('keyup', '#form-update-password input[name=password], #form-update-password input[name=repassword]', function() {
		var password = $('#form-update-password input[name=password]').val();
		var repassword = $('#form-update-password input[name=repassword]').val();
		check_pw('#form-update-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
		
	});

	$(document).on('keyup', '#form-password input[name=password], #form-password input[name=repassword]', function() {
		var password = $('#form-password input[name=password]').val();
		var repassword = $('#form-password input[name=repassword]').val();
		check_pw('#form-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
		
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification du mot de passe
	$(document).on('submit', '#form-update-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);

				$('input[type=password]').each(function(){
					$(this).val('');
				});

				$('ul.list-styled li').removeClass('valid-regex');
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// newsletter
	$(document).on('submit', '#form-newsletter', function(e) {
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/newsletter.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				
				$.get(path+'Connections/request/xhr/contact/newsletter-success.php', function(response2) {
					$this.before(response2);
					$this.remove();
				});			    
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
					$this.find('#'+item).addClass('input__field--error');
				});
			}
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// contact form
	$(document).on('submit', '#form-contact', function(e) {
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);
		$(this).find('i').removeClass('d-none');

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/contact.php', data, function(response) {
			if(response.action == 'success') {		
				toastr.success(response.msg);

				$.get(path+'Connections/request/xhr/contact/contact-success.php', function(response2) {
					$this.before(response2);
					$this.remove();
				});			    
			}
			else if(response.action == 'empty') {	
				toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
					$this.find('#'+item).addClass('input__field--error');
				});
			}
			else {	
				toastr.error(response.msg);				
			}
		}, 'json'); 

		e.preventDefault();
		return false;
	});

	// form formation sur mesure
	$(document).on('submit', '#form-formation-sur-mesure', function(e) {
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);
		$(this).find('i').removeClass('d-none');

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/formation-sur-mesure.php', data, function(response) {
			if(response.action == 'success') {	
				toastr.success(response.msg);
				
				$.get(path+'Connections/request/xhr/contact/formation-sur-mesure-success.php', function(response2) {
					$this.before(response2);
					$this.remove();
				});			    
			}
			else if(response.action == 'empty') {	
				toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
					$this.find('#'+item).addClass('input__field--error');
				});
			}
			else {	
				toastr.error(response.msg);				
			}
		}, 'json'); 

		e.preventDefault();
		return false;
	});

	function pagination(page_size = 10, start = null){
        //Pagination
        //pageSize = 10;
        pageSize = page_size;
        incremSlide = 8;
        startPage = 0;
        numberPage = 1;
        $('.pagination').html('');
        var pageCount =  $(".filter-me").length / pageSize;
        
        /*if($('.filter-me').length == 0){
        	$('.alert').addClass('alert-danger');
        	$('.alert').html('<i class="fa fa-times fa-fw"></i> Désolé, aucun résultat n\'a été trouvé');
        	$('.alert').show();
        }else{
        	$('.alert').removeClass('alert-danger');
        	$('.alert').html('');
        	$('.alert').hide();
        }*/
        //var totalSlidepPage = Math.floor(pageCount / incremSlide);
        var totalSlidepPage = Math.ceil(pageCount);
        for(var i = 0 ; i<pageCount;i++){
        	var active_class = '';
        	
            /*if(i+1 == start) {
            	active_class = 'active';
            }
            else */if(i == 0 && start == null){
            	active_class = 'active';
            }
            $(".pagination").append('<li id="pag'+(i+1)+'" class="page-item '+active_class+'"><a class="page-link" style="cursor:pointer;">'+(i+1)+'</a></li> ');
            if(i>pageSize){
            	$(".pagination li").eq(i).hide();
            }
        }
        $(".pagination li").hide();
        for(t=startPage;t<incremSlide;t++){
        	$(".pagination li").eq(t).show();
        }
        /*if(totalSlidepPage > 1){*/
        	var prev = $('<li class="page-item prev"><a class="page-link" style="cursor:pointer;" aria-label="Prev"><span aria-hidden="true"><i class="fas fa-chevron-left"></i></span></a><li>').click(function(){
        		startPage-=1;
        		incremSlide-=1;
        		numberPage--;
        		slide();
        	});
        	prev.hide();
        	var next = $('<li class="page-item next"><a class="page-link" style="cursor:pointer;" aria-label="Next"><span aria-hidden="true"><i class="fas fa-chevron-right"></i></span></a><li>').click(function(){
        		startPage+=1;
        		incremSlide+=1;
        		numberPage++;
        		slide();
        	});
        	$(".pagination").prepend(prev).append(next);
        	/*}*/
        	$(".pagination li").first().find("a").addClass("current");
        	slide = function(sens){
        		$(".pagination li").hide();
        		for(t=startPage-2;t<incremSlide;t++){
        			$(".pagination li").eq(t+1).show();
        		}
        		if(numberPage == 1){
        			next.show();
        			prev.hide();
        		}else if(numberPage == totalSlidepPage ){
        			next.hide();
        			prev.show();
        		}else{
        			next.show();
        			prev.show();
        		}
        		$('#pag'+numberPage).addClass('active');
        		$('#pag'+numberPage).find('a').addClass('current');
        		showPage(numberPage);
        	}
        	showPage = function(page) {
        		$(".filter-me").hide();
        		$(".filter-me").each(function(n) {
        			if (n >= pageSize * (page - 1) && n < pageSize * page)
        				$(this).show();
        		});        
        	}
        	showPage(1);
        	$(".pagination li a").eq(0).addClass("current");
        	$(".pagination li a").eq(0).parent().addClass("active");
        	$(".pagination li a").click(function() {
        		$(".pagination li a").removeClass("current");
        		$(".pagination li a").parent().removeClass("active");
        		$(this).addClass("current");
        		$(this).parent().addClass("active");
        		showPage(parseInt($(this).text()));
        		if($.isNumeric(parseInt($(this).text()))){
        			numberPage = parseInt($(this).text());
        			if(numberPage == 1){
        				next.show();
        				prev.hide();
        			}else if(numberPage == totalSlidepPage ){
        				next.hide();
        				prev.show();
        			}else{
        				next.show();
        				prev.show();
        			}
        		}
        	});

        	if(start != null) {

        		$(".pagination li a").removeClass("current");
        		$(".pagination li a").parent().removeClass("active");
            // $(this).addClass("current");
            $('#pag'+start).addClass("active");
            showPage(start);
            if($.isNumeric(start)){
            	numberPage = start;
            	if(numberPage == 1){
            		next.show();
            		prev.hide();
            	}else if(numberPage == totalSlidepPage ){
            		next.hide();
            		prev.show();
            	}else{
            		next.show();
            		prev.show();
            	}
            }
        }
        
    }

    var xhr;
    function search_recrutement(path) {
    	var filter = [];
    	var search = $('#search-job').val();
    	var page = $('#paginations .page-item.active').attr('id');
    	if (page === undefined) {
    		page = 1;
    	}

    	$('input[data-cat]:checked').each(function(i) {
    		filter.push($(this).data('cat'));
    	});

    	if(xhr && xhr.readyState != 4){
    		xhr.abort();
    	}

    	xhr = $.post(path+'Connections/request/xhr/recrutement/filter.php', { filter: filter, search: search, page: page, token: token}, function(response) {
    		if(response.action == 'success') {	
    			$('[data-job]').hide();
    			$('[data-job]').removeClass('filter-me');
    			$.each(response.job, function(i, item) {					    
    				$('[data-job="'+item+'"]').addClass('filter-me');
    			});

    			pagination(5);
    			
    		}
    		else if(response.action == 'empty') {	
    			toastr.warning(response.msg);
    		}
    		else {	
    			toastr.error(response.msg);				
    		}
    	}, 'json'); 
    }

    if($('#recrutement')) {
    	var nbr_job_page = 10;

    	pagination(nbr_job_page);

    	if (sessionStorage.getItem('job-page')) {
    		pagination(nbr_job_page, sessionStorage.getItem('job-page'));
    		sessionStorage.removeItem('job-page');
    	}
    	else {
    		pagination(nbr_job_page);
    	}

    	$(document).on('click', 'input[data-cat]', function(e) {
    		search_recrutement(path);
    	});

    	$(document).on('keyup', '#search-job', function(e) {
    		search_recrutement(path);
    	});

    	$(document).on('click', '.job-details', function(e) {
    		e.preventDefault();	
    		
    		var $this = $(this);
    		var filter = [];
    		var search = $('#search-job').val();
    		var page = $('#paginations .page-item.active').attr('id');

    		$('input[data-cat]:checked').each(function(i) {
    			filter.push($(this).data('cat'));
    		});

    		$.post(path+'Connections/request/xhr/recrutement/filter.php', { filter: filter, search: search, page: page, token: token}, function(response) {
    			if(response.action == 'success') {
    				location.href = $this.attr('href');				   	    
    			}
    			else if(response.action == 'empty') {	
    				toastr.warning(response.msg);
    			}
    			else {	
    				toastr.error(response.msg);				
    			}
    		}, 'json');
    	});

    	$(document).on('click', '[data-page]', function(e) {
    		e.preventDefault();

    		var page = $(this).data('page');

    		sessionStorage.setItem('job-page', page);
    		location.href = $(this).attr('href');
    	});	

    }

    function search_training(path) {
    	var filter = [];
    	var cat = [];
    	var search = $('#search-training').val();
    	var page = $('#paginations .page-item.active').attr('id');
    	if (page === undefined) {
    		page = 1;
    	}

    	$('input[data-cat]:checked').each(function(i) {
    		filter.push($(this).val());
    		cat.push($(this).data('cat'));
    	});

    	var duree = $('#duree-hour').val();
    	var range = $('#ipi-hour').val();

    	if(xhr && xhr.readyState != 4){
    		xhr.abort();
    	}

    	xhr = $.post(path+'Connections/request/xhr/formation/filter.php', { filter: filter, cat: cat, duree: duree, range: range, search: search, page: page, token: token }, function(response) {
    		if(response.action == 'success') {	
    			$('[data-training]').hide();
    			$('[data-training]').removeClass('filter-me');
    			$.each(response.training, function(i, item) {					    
    				$('[data-training="'+item+'"]').addClass('filter-me');
    			});

    			pagination(5);
    			
    		}
    		else if(response.action == 'empty') {	
    			toastr.warning(response.msg);
    		}
    		else {	
    			toastr.error(response.msg);				
    		}
    	}, 'json'); 
    }

    if($('#training')) {
    	var nbr_training_page = 5;

    	pagination(nbr_training_page);
    	
    	if (sessionStorage.getItem('training-page')) {
    		pagination(nbr_training_page, sessionStorage.getItem('training-page'));

    		var scrollto = $('[data-training="'+sessionStorage.getItem('training-id')+'"]').offset().top;

    		$("body, html").animate({
    			scrollTop: scrollto
    		}, 100 );

    		sessionStorage.removeItem('training-page');
    		sessionStorage.removeItem('training-id');
    	}
    	else {
    		pagination(nbr_training_page);
    	}

    	$(document).on('click', 'input[data-cat]', function(e) {
    		search_training(path);
    	});

    	$(document).on('keyup', '#training #search-training', function(e) {
    		search_training(path);
    	});

    	$(document).on('click', '.training-details', function(e) {
    		e.preventDefault();	
    		
    		var $this = $(this);
    		var filter = [];
    		var cat = [];
    		var search = $('#search-training').val();
    		var page = $('#paginations .page-item.active').attr('id');	
    		if (page === undefined) {
    			page = 1;
    		}		

    		$('input[data-cat]:checked').each(function(i) {
    			filter.push($(this).val());
    			cat.push($(this).data('cat'));
    		});

    		var duree = $('#duree-hour').val();
    		var range = $('#ipi-hour').val();

    		$.post(path+'Connections/request/xhr/formation/filter.php', { filter: filter, cat: cat, duree: duree, range: range, search: search, page: page, token: token }, function(response) {
    			if(response.action == 'success') {
    				location.href = $this.attr('href');				   	    
    			}
    			else if(response.action == 'empty') {	
    				toastr.warning(response.msg);
    			}
    			else {	
    				toastr.error(response.msg);				
    			}
    		}, 'json');
    	});

    	$(document).on('click', '[data-page]', function(e) {
    		e.preventDefault();

    		var page = $(this).data('page');
    		var id = $(this).data('training-id');

    		sessionStorage.setItem('training-page', page);
    		sessionStorage.setItem('training-id', id);
    		location.href = $(this).attr('href');
    	});	

    }

	// filter CLL vs E-learning
	$(document).on('click', '#modalite-cll, #cll', function() {
		console.log($(this).is(':checked'));
		if($(this).is(':checked')) {
			$('#modalite-cll, #cll').prop('checked', true);
		}
		else {
			$('#modalite-cll, #cll').prop('checked', false);
		}

		search_training(path);

	});

	if($('#ipi-hour').length >0) {
		var duree_hour = $('#duree-hour');
		duree_hour.ionRangeSlider({
			skin: 'round',
			grid: false,
			prettify_enabled: false
		});

		var duree_hour_data = duree_hour.data("ionRangeSlider");

		duree_hour.on("change", function () {
	        var range = $(this).val().split(';'); // reading input value
	        var min = $(this).data("min");
	        var max = $(this).data("max");

	        search_training(path);	        
	    });	

		var ipi_hour = $('#ipi-hour');
		ipi_hour.ionRangeSlider({
			skin: 'round',
			grid: false,
			prettify_enabled: false
		});

		var ipi_hour_data = ipi_hour.data("ionRangeSlider");

		ipi_hour.on("change", function () {
	        var range = $(this).val().split(';'); // reading input value
	        var min = $(this).data("min");
	        var max = $(this).data("max");

	        search_training(path);	        
	    });	
	}

	$(document).on('click', '.modal-subscription-btn', function(e) {
		e.preventDefault();

		var type = $(this).data('type');

		if($(this).closest('[data-id]').data('id') == undefined) {
			var id = 'tmp';
		}
		else {
			var id = $(this).closest('[data-id]').data('id');
		}


		$('#modal-subscription #type').val(type);
		$('#modal-subscription #session').val(id);
		$('#modal-subscription').modal('show');
	});

	if($('#calendar').length > 0) {
		$.getJSON('/Connections/request/xhr/formation/get-training.php', function(response) {
			var training = response.training;

			$("#calendar").simpleCalendar({

                // displays events
                displayEvent: true,

                // event dates
                events: response.training,

                // disable showing event details
                disableEventDetails: false,

                // disable showing empty date details
                disableEmptyDetails: false,
                months: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
                days: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],

            });
		});            
	}

	$(document).on('click', '.preview-video', function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var title = $(this).closest('.card').find('.video-title').html();
		$('#modal-preview-video').find('source').attr('src', href+ '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
		$('#video-preview')[0].load();
		$('#modal-preview-video').modal('show');
		$('#modal-preview-video .modal-title').html(title);
		$('#video-preview')[0].play();
		$('#video-preview').prop('muted', false);
	});

	$('#modal-preview-video').on('hidden.bs.modal', function () {
		$('#video-preview')[0].pause();
		$('#modal-preview-video .modal-title').html('aa');
	});
	
    // CASE INSENSITIVE FUNCTION.
    jQuery.expr[':'].contains = function(a, i, m) {
    	var rExps=[
    	{re: /[\xC0-\xC6]/g, ch: "A"},
    	{re: /[\xE0-\xE6]/g, ch: "a"},
    	{re: /[\xC8-\xCB]/g, ch: "E"},
    	{re: /[\xE8-\xEB]/g, ch: "e"},
    	{re: /[\xCC-\xCF]/g, ch: "I"},
    	{re: /[\xEC-\xEF]/g, ch: "i"},
    	{re: /[\xD2-\xD6]/g, ch: "O"},
    	{re: /[\xF2-\xF6]/g, ch: "o"},
    	{re: /[\xD9-\xDC]/g, ch: "U"},
    	{re: /[\xF9-\xFC]/g, ch: "u"},
    	{re: /[\xC7-\xE7]/g, ch: "c"},
    	{re: /[\xD1]/g, ch: "N"},
    	{re: /[\xF1]/g, ch: "n"}
    	];

    	var element = $(a).text();
    	var search  = m[3];

    	$.each(rExps, function() {
    		element    = element.replace(this.re, this.ch);
    		search     = search.replace(this.re, this.ch);
    	});

    	return element.toUpperCase()
    	.indexOf(search.toUpperCase()) >= 0;
    };

    $('#valid-privacy').click(function() {
    	$.cookie('privacy', 'ok', { expires: 365, path: '/' });
    	$("#bottom-privacy").slideUp(500, function() {
    		$(this).remove();
    	});
    });
    /*!
     * jQuery Cookie Plugin v1.4.1
     * 
     * Copyright 2013 Klaus Hartl
     * Released under the MIT license
     */
     (function (factory) {
     	if (typeof define === 'function' && define.amd) {
            // AMD
            define(['jquery'], factory);
        } else if (typeof exports === 'object') {
            // CommonJS
            factory(require('jquery'));
        } else {
            // Browser globals
            factory(jQuery);
        }
    }(function ($) {

    	var pluses = /\+/g;

    	function encode(s) {
    		return config.raw ? s : encodeURIComponent(s);
    	}

    	function decode(s) {
    		return config.raw ? s : decodeURIComponent(s);
    	}

    	function stringifyCookieValue(value) {
    		return encode(config.json ? JSON.stringify(value) : String(value));
    	}

    	function parseCookieValue(s) {
    		if (s.indexOf('"') === 0) {
                // This is a quoted cookie as according to RFC2068, unescape...
                s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
            }

            try {
                // Replace server-side written pluses with spaces.
                // If we can't decode the cookie, ignore it, it's unusable.
                // If we can't parse the cookie, ignore it, it's unusable.
                s = decodeURIComponent(s.replace(pluses, ' '));
                return config.json ? JSON.parse(s) : s;
            } catch(e) {}
        }

        function read(s, converter) {
        	var value = config.raw ? s : parseCookieValue(s);
        	return $.isFunction(converter) ? converter(value) : value;
        }

        var config = $.cookie = function (key, value, options) {

            // Write

            if (value !== undefined && !$.isFunction(value)) {
            	options = $.extend({}, config.defaults, options);

            	if (typeof options.expires === 'number') {
            		var days = options.expires, t = options.expires = new Date();
            		t.setTime(+t + days * 864e+5);
            	}

            	return (document.cookie = [
            		encode(key), '=', stringifyCookieValue(value),
                    options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    options.path    ? '; path=' + options.path : '',
                    options.domain  ? '; domain=' + options.domain : '',
                    options.secure  ? '; secure' : ''
                    ].join(''));
            }

            // Read

            var result = key ? undefined : {};

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling $.cookie().
            var cookies = document.cookie ? document.cookie.split('; ') : [];

            for (var i = 0, l = cookies.length; i < l; i++) {
            	var parts = cookies[i].split('=');
            	var name = decode(parts.shift());
            	var cookie = parts.join('=');

            	if (key && key === name) {
                    // If second argument (value) is a function it's a converter...
                    result = read(cookie, value);
                    break;
                }

                // Prevent storing a cookie that we couldn't decode.
                if (!key && (cookie = read(cookie)) !== undefined) {
                	result[name] = cookie;
                }
            }

            return result;
        };

        config.defaults = {};

        $.removeCookie = function (key, options) {
        	if ($.cookie(key) === undefined) {
        		return false;
        	}

            // Must not alter options, thus extending a fresh object...
            $.cookie(key, '', $.extend({}, options, { expires: -1 }));
            return !$.cookie(key);
        };
    }));
     
 });

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if(lowerCasePattern.test(pw)) {		    
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

    // At least one UPPERCASE character:
    var upperCasePattern = /^(?=.*[A-Z]).+$/;
    
    if(upperCasePattern.test(pw)) {		    
    	$('.uppercase').addClass('valid-regex');
    }
    else {
    	$('.uppercase').removeClass('valid-regex');
    	test = false;
    }

    // At least one NUMBER:
    var numberPattern = /^(?=.*[\d]).+$/;
    
    if(numberPattern.test(pw)) {		    
    	$('.number').addClass('valid-regex');
    }
    else {
    	$('.number').removeClass('valid-regex');
    	test = false;
    }

    // At least one SPECIAL character:
    var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

    if(specialCharacterPattern.test(pw)) {		    
    	$('.specialcase').addClass('valid-regex');
    }
    else {
    	$('.specialcase').removeClass('valid-regex');
    	test = false;
    }

    // At least 8 characters in the screen:
    var characterCountPattern = /^.{8,}/;

    if(characterCountPattern.test(pw)) {		    
    	$('.minimumcase').addClass('valid-regex');
    }
    else {
    	$('.minimumcase').removeClass('valid-regex');
    	test = false;
    }

    if($('.not-secure li').length == $('.valid-regex').length) {
    	$this.closest('form').addClass('valid');
    }
    else {
    	$this.closest('form').removeClass('valid');
    }
}

